import { useQuery } from "@apollo/client";
import { GetEmployersQuery, GetEmployersQueryVariables } from "generated/graphql";
import queries from "Shared/queries";

export const useEmployers = (variables?: GetEmployersQueryVariables) => {
  const { data } = useQuery<GetEmployersQuery, GetEmployersQueryVariables>(
    queries.GET_EMPLOYERS,
    {
      variables: {
        page: 1,
        perPage: 200,
        ...variables,
      },
    }
  );

  return {
    employers: data?.employer.currentProvider.employers.items || [],
  };
};
